<template>
  <validation-observer ref="dataForm">
    <b-row v-if="files.length > 0">
      <b-col lg="12">
        <b-list-group flush>
          <b-list-group-item v-for="file in files" :key="file.id">
            <b-row>
              <b-col lg="4">
                <a
                  class="btn btn-outline-primary btn-block"
                  :href="file.data_path"
                >
                  {{ $t("activities.press_to_download") }}
                </a></b-col
              ><b-col lg="3">
                <b-badge   v-if="variant(file)">

                </b-badge>
                <b-badge
                  variant="light-danger"
                  v-else-if="file.master_key_status.value === 0"
                >
                  تم الرفض
                </b-badge>
                <b-badge
                  variant="light-success"
                  v-else-if="file.master_key_status.value === 1"
                >
                  تم الموافقة
                </b-badge>
              </b-col>
              <b-col lg="3">
                <b-button variant="outline-info" block @click="showCom(file)">
                  عرض التعلقات
                </b-button>
              </b-col>
              <b-col lg="2">
                <b-badge variant="light-info" class="d-block">
                  رفع :{{ moment(file.updated_at).fromNow() }}
                </b-badge>
              </b-col></b-row
            ></b-list-group-item
          >
        </b-list-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col lg="10">
        <b-form-group
          id="input-group-CERT"
          :label="label"
          label-for="input-CERT"
          label-cols-md="2"
        >
          <validation-provider
            #default="{ errors }"
            :name="label"
            vid="data"
            rules="required"
          >
            <b-form-file v-model="newItem.data" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col lg="2">
        <b-button variant="outline-primary" @click="upload()">
          رفع
        </b-button></b-col
      >
    </b-row>
    <hr />
    <b-row v-for="file in files" :key="file.id">
      <b-col lg="12" v-if="commentableid != 0 && commentableid == file.id">
        <comment-vue
          :commentableid="commentableid"
          :commentabletype="'App\MastersData'"
          ref="comment"
        ></comment-vue>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, min_value, max_value } from "@validations";
import MastersDataController from "@/Controllers/MastersDataController";
import CommentVue from "@/views/Page/Activities/components/Comment.vue";

export default {
  props: {
    datakey: String,
    master: Number,
    files: Array,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    required,
    min_value,
    max_value,
    CommentVue,
  },
  data() {
    return {
      newItem: {},
      label: this.$i18n.t(`master.` + this.datakey),
      ret: {},
      commentableid: 0,
    };
  },
  async created() {},
  methods: {
        variant(item) {
          return true
      // return (
      //   item.master_key_status === null ||
      //   item.master_key_status.value === null ||
      //   item.master_key_status.value === "" ||
      //   item.master_key_status.value === "-1"
      // );
    },
    async upload() {
      const isValid = await this.$refs.dataForm.validate();
      if (!isValid) {
        return { valid: false };
      }
      this.newItem.key = this.datakey
      
      this.newItem.master_id = this.master;
      this.ret = await new MastersDataController().From(
        this.newItem,
        "FormData",
        true
      );
    },
    showCom(file) {
      this.commentableid = 0;

      this.commentableid = file.id;
      this.$refs.comment.$forceUpdate();
    },
    async returnData() {
      if (this.files.length > 0) {
        return { valid: true, data: this.files };
      }

      if (!this.ret) {
        return { valid: false };
      }
      return { valid: true, data: this.newItem };
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
